import BigNumber from 'bignumber.js'
import { BaseLcdService } from 'services/base/baseLcdService'
import { toAssetInfo } from 'utils/contractParse'

// NOTE: Currently using Mirror's collateral oracle
//       Implemented as draft before using Edge Oracle
export class OraclePriceService extends BaseLcdService {
  /**
   * Get price from oracle
   * @param baseAsset
   * @param quoteAsset
   * @returns
   */
  getPrice = async (oracleAddr: string, assetAddr: string) => {
    // TODO: assign type
    const res: any = await this.contractQuery(oracleAddr, {
      price: {
        asset_token: toAssetInfo(assetAddr),
      },
    })

    return new BigNumber(res.rate as string)
  }
}

export const oraclePriceService = new OraclePriceService()
